import _merge from 'lodash/merge';
import { Skeleton } from '../../tornado/skeleton/skelton.component';
import { getInitialStyle } from './search.skeleton.style';

/**
 * A loading placeholder of the Search page: a search field, a keyboard and a search history on the left,
 * and configurable result rows on the right, filled by the inherited `rows` setter.
 *
 * @see ../search.component.js
 */
export class SearchSkeleton extends Skeleton {
  static _template() {
    return _merge(
      // NOTE: a Lightning template is not inherited, so the base one is merged in explicitly
      super._template(),
      {
        Background: {
          rect: true,
        },
        SearchField: {},
        Keyboard: {
          Keys: {},
        },
        SearchHistory: {
          Items: {},
        },
        Rows: {},
      },
      getInitialStyle(),
    );
  }

  get ignoresContentPadding() {
    return true;
  }

  // NOTE: search results are sized for the area left of the keyboard, hence their own item and block sizes
  get isSearchPage() {
    return true;
  }
}
